import React from "react"
import { StoreProvider } from "./src/context/store-context"
import { InterfaceProvider } from "./src/context/InterfaceContext"
import { withPrefix, Script } from "gatsby"
import QueryRootElement from "./query-root-element"
import { AccountProvider } from "./src/context/AccountContext"
import { routes } from "./src/routes"
import "./src/styles/global.css"
import { CookieBanner } from "./src/components/cookie/CookieBanner"
import { CookieModal } from "./src/components/cookie/CookieModal"
import { GlobalModalsProvider } from "./src/context/GlobalModalsContext"
import { ErrorBoundaryComponent } from "./src/components/ErrorBoundaryComponent"
import { I18nextProvider } from "react-i18next"
import i18n from "./src/i18n"
import { setHTMLTagLang } from "./src/util/util"

export const wrapRootElement = ({ element }) => {
  const pathname = window.location.pathname

  const COOKIEYES_URL = process.env.GATSBY_COOKIEYES_URL

  return (
    <ErrorBoundaryComponent>
      <QueryRootElement>
        <GlobalModalsProvider>
          <InterfaceProvider>
            <StoreProvider>
              {process.env.GATSBY_MESSENGER_SCRIPT_NAME && (
                <Script
                  src={withPrefix(process.env.GATSBY_MESSENGER_SCRIPT_NAME)}
                />
              )}
              <AccountProvider>{element}</AccountProvider>
              <I18nextProvider i18n={i18n}>
                {!COOKIEYES_URL &&
                  !pathname.includes(routes.cardForm) &&
                  !pathname.includes(routes.legal.cookies) && (
                    <>
                      <CookieBanner />
                      <CookieModal />
                    </>
                  )}
              </I18nextProvider>
            </StoreProvider>
          </InterfaceProvider>
        </GlobalModalsProvider>
      </QueryRootElement>
    </ErrorBoundaryComponent>
  )
}

export const onRouteUpdate = ({ location }) => {
  const pathParts = location.pathname.split("/")
  const newLang = pathParts[1] || "en"

  if (i18n.language !== newLang) {
    i18n.changeLanguage(newLang)
  }

  setHTMLTagLang(newLang)
}
